/* eslint-disable react/jsx-props-no-spreading */
import { FormattedMessage, useIntl } from 'react-intl';

import CoorsFeedback from './CoorsFeedback';

import canImageEn from '../../../img/coorslive/coorsoriginal_can_en.png';
import canImageFr from '../../../img/coorslive/coorsoriginal_can_fr.png';

const CoorsoriginaFeedback = (props) => {
    const { locale } = useIntl();
    const image = locale === 'fr' ? canImageFr : canImageEn;
    return (
        <CoorsFeedback
            image={image}
            validLabel="YEEEHAW"
            invalidLabel={
                <FormattedMessage defaultMessage="Nice try!" description="Feedback label" />
            }
            {...props}
        />
    );
};

export default CoorsoriginaFeedback;
